import React from 'react';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { GeoPoint } from '@youhelp-ru/core';
import { SxProps, styled } from '@cp/ds/src/theme';
import { Button } from '@cp/ds/src/components/button';
import { Box } from '@cp/ds/src/components/box';
import { LazyMap, Map } from 'src/shared/ui/map';

export interface CatalogItemMapProps {
  location?: GeoPoint;
  sx?: SxProps;
}

const MAP_HEIGHT_DESKTOP = 400;
const MAP_HEIGHT_MOBILE = 220;

const StyledLazyMap = styled(LazyMap)(({ theme }) => ({
  border: `2px solid ${theme.palette['gray middle']}`,
  borderRadius: '12px',
  minHeight: '80px',
  '@container(min-width: 600px)': {
    borderRadius: '24px',
  },
}));

const MapWrapper = styled(Box)({
  height: MAP_HEIGHT_MOBILE,
  '@container(min-width: 600px)': {
    height: MAP_HEIGHT_DESKTOP,
  },
});

export const CatalogItemMap: React.FC<CatalogItemMapProps> = ({ location, sx }) => {
  const theme = useTheme();

  return (
    // wrap in container because Container component from @cp/ds not supports container queries yet
    <Box sx={{ containerType: 'inline-size' }}>
      <StyledLazyMap
        Button={(props) => (
          <Button color="pink" size="small" sx={{ backgroundColor: theme.palette.background.default }} variant="secondary" {...props} />
        )}
        renderMap={(props) => (
          <MapWrapper>
            <Map center={location} marker={location} sx={{ height: '100%' }} {...props}>
              Карта с местом выполнения работы
            </Map>
          </MapWrapper>
        )}
        sx={sx}
      />
    </Box>
  );
};
